import React from 'react'
import PropTypes from 'prop-types'
import OrLine from '../components/orLine'
import { localsMessages } from '../utility/getTemplateData'

const messages = localsMessages('guest/guestButton')
const STYLES = {
	orLine: {
		maxWidth: 350,
		clear: 'both',
		margin: 'auto',
	},
	button: {
		maxWidth: 350,
		marginTop: 8,
		marginBottom: 10,
		fontFamily: 'pp-sans-big-medium'
	}
}

class GuestButton extends React.Component {
	constructor() {
		super();
	}

	render () {
		const { label: { debitorcredit = '' } = {} } = messages;
		return (
			<div>
				<div style={{ ...STYLES.orLine }}>
					<OrLine />
				</div>
				<div className="col-xs-12 col-sm-12 col-md-12 text-center">
					<a href="#"
						style={{ ...STYLES.button }}
						className="vx_btn vx_btn-block vx_btn-secondary"
						id="payWithGuest"
						disabled={this.props.disabled}
						onClick={this.props.handleGuest}>
						{debitorcredit}
					</a>
				</div>
			</div>
		);
	}
}

GuestButton.propTypes = {
	label: PropTypes.string,
	disabled: PropTypes.bool,
	handleGuest: PropTypes.func,
};

export default GuestButton



// WEBPACK FOOTER //
// ./components/guestButton.js